import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=524784af&lang=pug&"
import script from "./Environment.vue?vue&type=script&lang=js&"
export * from "./Environment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524784af')) {
      api.createRecord('524784af', component.options)
    } else {
      api.reload('524784af', component.options)
    }
    module.hot.accept("./Environment.vue?vue&type=template&id=524784af&lang=pug&", function () {
      api.rerender('524784af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/docs/Environment.vue"
export default component.exports